import React, { useState } from "react";
import { Alert } from '@mui/material';
import PushPinIcon from '@mui/icons-material/PushPin';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ScaleIcon from '@mui/icons-material/Scale';
import { useNavigate } from "react-router-dom";
import CallIcon from '@mui/icons-material/Call';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import axios from "axios";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// "../../environment";
import img1 from '../../../Assets/add/img1.png'
import icon1 from '../../../Assets/vehicle/icon1.svg'
import icon2 from '../../../Assets/add/icon2.svg'
import icon3 from '../../../Assets/add/icon3.svg'
import img3 from '../../../Assets/add/img3.png'
import img2 from '../../../Assets/add/img2.png'
import img4 from '../../../Assets/add/img4.png'
import img5 from '../../../Assets/add/img5.png'
import rightarrow from '../../../Assets/navbar/right-arrow.svg'

import MapForVendorDistance from "../Map/MapForVendorDistance";

const LookingForAccptance = (props) => {
    const navigate = useNavigate()
    const [isUpdateData, setIsUpdateData] = useState(false)
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', severity: 'info' });
    const userId = localStorage.getItem('userId')
    const token = localStorage.getItem('token')

    console.log("props.accidentData", props.fromPage)
    console.log("props.accidentData", props)

    const [formData, setFormData] = useState({
        onSpotName: props.accidentData.onSpotName,
        onSpotContact: props.accidentData.onSpotContact,
        quantity: props.accidentData.quantity,
        accidentImage1: null,
        accidentImage2: null,
        accidentImage3: null,
        accidentImage4: null,
    })

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === 'file') {
            if (files[0] && files[0].size > 2097152) {
                setAlertInfo({ show: true, message: 'File size should be less than 2 MB!', severity: 'error' });
            }
            setFormData(prevState => ({
                ...prevState,
                [name]: files[0]
            }));
        }
        else {
            setFormData({
                ...formData,
                [name]: value,
            })
        }
    }
    console.log('formData', formData)

    const submitUpdatedData = async (e) => {
        e.preventDefault();
        const formDataObj = new FormData();
        for (const key in formData) {
            if (formData[key] !== undefined && formData[key] !== null && formData[key] !== "") {
                if (formData[key] instanceof File) {
                    formDataObj.append(key, formData[key], formData[key].name);
                } else {
                    formDataObj.append(key, formData[key]);
                }
            }
        }
        let response;
        // Debugging FormData contents
        for (let pair of formDataObj.entries()) {
            console.log(`${pair[0]}:`, pair[1]);
        }

        try {
            response = await axios({
                method: 'PUT',
                url: `${process.env.REACT_APP_BACKEND_URL}/api/updateAccidentData/${props.accidentData.AccidentVehicleCode}/${userId}`,
                data: formDataObj,
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            console.log("response", response.data);
            if (response.data.message === 'update data') {
                setAlertInfo({ show: true, message: response.data.message, severity: 'success' });
                props.setUpdatedData(true)
            }
            else {
                setAlertInfo({ show: true, message: 'some issue occures', severity: 'error' });
            }
        } catch (error) {
            console.error("Error during form submission:", error);
            const errorMessage = error.response?.data?.message || 'An error occurred';
            if (errorMessage === "jwt expired") {
                setTimeout(() => {
                    window.location.href = '/';
                }, 2000);
            }
        }
    }

    return (
        <div>
            {props.fromPage !== 'quotationUpdate' && props.fromPage !== 'AllVehicles' && (<h3 className='text-2xl font-semibold mb-5'>Looking For Vehicle</h3>)}
            {props.fromPage === 'AllVehicles' && (
                <div className="flex justify-end">
                    <div className="bg-[#21A6E9] flex items-center max-w-[200px] p-1 my-4 mr-2 justify-center w-full mt-[20px]  rounded-full  cursor-pointer">
                        <button onClick={() => { setIsUpdateData(!isUpdateData) }} className="font-satoshi font-[400] text-[20px] leading-[33.6px] pr-[8px] text-[#FFFFFF]">Update Details</button>
                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[40px] w-[40px]' alt="" />
                    </div>
                </div>
            )}

            {/* <div className='flex gap-2 justify-between flex-col items-center'> */}
            {/* <div>
                    {props.vehicleType === 'crane,recoveryVan' && (
                        <div className="flex flex-row">
                            <img className='h-[65px] w-[74px] mt-[15px] p-2' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGO-VK9DCPXVGAmbx27ErrmIbqaJBMfJcAYw&s" alt="crane" />
                            <p className="m-1 mt-4 mt-[30px]"><AddIcon /></p>
                            <img className='h-20 w-20 p-2' src="https://toppng.com/uploads/preview/crane-png-indo-power-crane-11563243373unjn5iufbu.png" alt="crane" />
                        </div>
                    )}
                    {props.vehicleType === 'crane' && (
                        <div>
                            <img className='h-20 w-20 p-2' src="https://toppng.com/uploads/preview/crane-png-indo-power-crane-11563243373unjn5iufbu.png" alt="crane" />
                        </div>
                    )}
                    {props.vehicleType === 'recoveryVan' && (
                        <div className="flex flex-row">
                            <img className='h-20 w-20 p-2' src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGO-VK9DCPXVGAmbx27ErrmIbqaJBMfJcAYw&s" alt="crane" />
                        </div>
                    )}
                </div>
                <div className="max-w-[694px] w-full bg-[#FFFFFF] rounded-[30px]">
                    <div className="grid grid-cols-2 gap-[24px]">
                        <div className="col-span-2">
                            <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Vehicle No</label>
                            <div>
                                {props.accidentData.regNo || props.accidentData.reg}
                            </div>
                        </div>
                        <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                            <LocalShippingIcon />
                            <div>
                                <h3 className='text-sm font-base font-semibold'>Your Vehicle Number</h3>
                                <p className='text-sm mt-1 text-gray-600'>{props.accidentData.regNo || props.accidentData.reg}</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                            <PersonIcon />
                            <div>
                                <h3 className='text-sm font-base font-semibold'>On Spot Person</h3>
                                {!isUpdateData && (<p className='text-sm mt-1 text-gray-600'>{props.accidentData.onSpotName}</p>)}
                                {isUpdateData && (
                                    <input
                                        type='text'
                                        name="onSpotName"
                                        placeholder='On Spot Name'
                                        value={formData.onSpotName}
                                        onChange={handleChange}
                                        className="form-control"
                                        style={{ border: '1px solid', borderRadius: '10px', textAlign: 'center' }}
                                        required
                                        pattern="\d{12}"
                                        title="Aadhaar number must be exactly 12 digits."
                                    />)}
                            </div>
                        </div>
                        <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                            <CallIcon />
                            <div>
                                <h3 className='text-sm font-base font-semibold'>Person Number</h3>
                                {!isUpdateData && (<p className='text-sm mt-1 text-gray-600'>{props.accidentData.onSpotContact}</p>)}
                                {isUpdateData && (
                                    <input
                                        type='text'
                                        name="onSpotContact"
                                        placeholder='On Spot Contact'
                                        value={formData.onSpotContact}
                                        onChange={handleChange}
                                        className="form-control"
                                        style={{ border: '1px solid', borderRadius: '10px', textAlign: 'center' }}
                                        required
                                        pattern="\d{12}"
                                        title="Aadhaar number must be exactly 12 digits."
                                    />)}
                            </div>
                        </div>
                        {props.accidentData.quantity != '' && (
                            <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                                <ScaleIcon />
                                <div>
                                    <h3 className='text-sm font-base font-semibold'>Quantity</h3>
                                    {!isUpdateData && (<p className='text-sm mt-1 text-gray-600'>{props.accidentData.quantity}</p>)}
                                    {isUpdateData && (
                                        <input
                                            type='text'
                                            name="quantity"
                                            placeholder='quantity'
                                            value={formData.quantity}
                                            onChange={handleChange}
                                            className="form-control"
                                            style={{ border: '1px solid', borderRadius: '10px', textAlign: 'center' }}
                                            required
                                            pattern="\d{12}"
                                            title="Aadhaar number must be exactly 12 digits."
                                        />)}
                                </div>
                            </div>)}
                        <div className='flex items-center gap-5 p-3 border-b-2' style={{ borderBottom: "1px solid black" }}>
                            <CheckBoxOutlineBlankIcon />
                            <div>
                                <h3 className='text-sm font-base'>Selected Option</h3>
                                <p className='text-sm mt-1 text-gray-600'>{props.accidentData.selectedOptions}</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                            <PushPinIcon />
                            <div>
                                <h3 className='text-sm font-base font-semibold'>From</h3>
                                <p className='text-sm mt-1 text-gray-600'>{props.accidentData.pickupLocation}</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                            <FmdGoodIcon />
                            <div>
                                <h3 className='text-sm font-base font-semibold'>Drop </h3>
                                <p className='text-sm mt-1 text-gray-600'>{props.accidentData.dropLocation}</p>
                            </div>
                        </div>
                        {(props.fromPage === 'quotationUpdate' || props.fromPage === 'AllVehicles') && (
                            <div className="pb-5 mb-5">
                                {(isUpdateData || props.accidentData.accidentImage1 !== null) && (
                                    <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                                        <ImageOutlinedIcon />
                                        <div>
                                            <h3 className='text-sm font-base font-semibold font-semibold'>Accident Image </h3>
                                            {!isUpdateData && (<img className='text-sm mt-1 text-gray-600' src={props.accidentData.accidentImage1} alt="PAN Card" style={{ width: '100%', borderRadius: '20px' }} />)}
                                            {isUpdateData && (
                                                <input
                                                    type="file"
                                                    name="accidentImage1"
                                                    onChange={handleChange}
                                                    accept="image/*"
                                                    className="form-control"
                                                    required
                                                />)}
                                        </div>
                                    </div>)}
                                {(isUpdateData || props.accidentData.accidentImage2 !== null) && (
                                    <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                                        <ImageOutlinedIcon />
                                        <div>
                                            <h3 className='text-sm font-base font-semibold font-semibold'>Accident Image 2</h3>
                                            {!isUpdateData && (<img className='text-sm mt-1 text-gray-600' src={props.accidentData.accidentImage2} alt="PAN Card" style={{ width: '100%', borderRadius: '20px' }} />)}
                                            {isUpdateData && (
                                                <input
                                                    type="file"
                                                    name="accidentImage2"
                                                    onChange={handleChange}
                                                    accept="image/*"
                                                    className="form-control"
                                                    required
                                                />)}
                                        </div>
                                    </div>)}
                                {(isUpdateData || props.accidentData.accidentImage3 !== null) && (
                                    <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                                        <ImageOutlinedIcon />
                                        <div>
                                            <h3 className='text-sm font-base font-semibold font-semibold'>Accident Image 3 </h3>
                                            {!isUpdateData && (<img className='text-sm mt-1 text-gray-600' src={props.accidentData.accidentImage3} alt="PAN Card" style={{ width: '100%', borderRadius: '20px' }} />)}
                                            {isUpdateData && (
                                                <input
                                                    type="file"
                                                    name="accidentImage3"
                                                    onChange={handleChange}
                                                    accept="image/*"
                                                    className="form-control"
                                                    required
                                                />)}
                                        </div>
                                    </div>)}
                                {(isUpdateData || props.accidentData.accidentImage4 !== null) && (
                                    <div className='flex items-center gap-5 p-3 border-b-2 ' style={{ borderBottom: "1px solid black" }}>
                                        <ImageOutlinedIcon />
                                        <div>
                                            <h3 className='text-sm font-base font-semibold font-semibold'>Accident Image 4 </h3>
                                            {!isUpdateData && (<img className='text-sm mt-1 text-gray-600' src={props.accidentData.accidentImage4} alt="PAN Card" style={{ width: '100%', borderRadius: '20px' }} />)}
                                            {isUpdateData && (
                                                <input
                                                    type="file"
                                                    name="accidentImage4"
                                                    onChange={handleChange}
                                                    accept="image/*"
                                                    className="form-control"
                                                    required
                                                />)}
                                        </div>
                                    </div>)}
                            </div>

                        )}
                        {alertInfo.show && (
                            <Alert className='mb-2' severity={alertInfo.severity} onClose={() => setAlertInfo({ ...alertInfo, show: false })}>
                                {alertInfo.message}
                            </Alert>
                        )}
                        {isUpdateData && (<button onClick={submitUpdatedData}
                            className="fixed w-half left-[1.5rem] mb-5 bottom-5 right-5 bg-green-900 text-white font-semibold p-3 rounded-lg shadow-lg">
                            Update Details
                        </button>

                        )}

                        {props.fromPage !== 'quotationUpdate' && props.fromPage !== 'AllVehicles' && (<button onClick={() => {
                            navigate('/all-accident-vehicles')
                        }} className='w-full mt-3 bg-green-900 text-white font-semibold p-3 rounded-lg'>Look For Vehicle</button>)}


                    </div>
                </div> */}

            <div className="bg-white flex md:flex-row flex-col justify-center gap-[30px] pt-[20px]">
                <div className="max-w-[694px] w-full bg-[#FFFFFF] rounded-[30px]">
                    <div className="grid grid-cols-2 gap-[24px] py-5">
                        <div className="col-span-2">
                            <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Vehicle No</label>
                            <div className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>
                                {props.accidentData.regNo || props.accidentData.reg}
                            </div>
                        </div>
                        <div className="md:col-span-1 col-span-2">
                            <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Spot Person</label>
                            <div>
                                {!isUpdateData && (<p className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>{props.accidentData.onSpotName}</p>)}

                                {isUpdateData && (
                                    <input
                                        type='text'
                                        style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }}
                                        className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full"
                                        placeholder='Enter Person'
                                        name="onSpotName"
                                        value={formData.onSpotName}
                                        onChange={handleChange}
                                        required
                                    />)}
                            </div>
                        </div>
                        <div className="md:col-span-1 col-span-2">
                            <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Spot Person Number</label>
                            <div>
                                {!isUpdateData && (<p className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>{props.accidentData.onSpotContact}</p>)}

                                {isUpdateData && (
                                    <input
                                        type='number'
                                        style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }}
                                        className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full"
                                        placeholder='On Spot Contact'
                                        name="onSpotContact"
                                        value={formData.onSpotContact}
                                        onChange={handleChange}
                                        required
                                    />)}
                                {/* <input type="number" name="" className='border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' id="" placeholder='Enter Number' /> */}
                            </div>
                        </div>
                        {props.accidentData.quantity != '' && (
                            <div className="col-span-2">
                                <label htmlFor="" className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>Quantity (Tons)</label>
                                <div>
                                    {!isUpdateData && (<p className='font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]'>{props.accidentData.quantity !== null ? props.accidentData.quantity : '0'}</p>)}
                                    {isUpdateData && (
                                        <input
                                            type='text'
                                            name="quantity"
                                            placeholder='Enter Quantity'
                                            value={formData.quantity}
                                            onChange={handleChange}
                                            style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '16px', paddingBottom: '16px' }}
                                            className="border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px]    w-full"
                                            required
                                        />)}
                                    {/* <input type="text" name="" className='border border-[#DEDEE8] bg-[#F6F6F6] rounded-[7px] py-[16px] px-[10px] w-full' id="" placeholder='Enter Quantity' /> */}
                                </div>
                            </div>
                        )}

                        <div className='h-[350px]  col-span-2 relative mt-[16px]'>
                            <div className="h-full w-full rounded-xl overflow-hidden">
                                <MapForVendorDistance className="h-full w-full rounded-xl" />
                            </div>
                            <div className="flex gap-[14px] flex-col w-full z-[1000] absolute px-[32px] bottom-[32px]">
                                <div style={{ boxShadow: "0px 2px 4px 0px #00000040" }} className="flex items-center justify-between rounded-[7px] bg-[#FFFFFF] py-[10px] px-[10px]">
                                    <div className="flex gap-[20px] items-center">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/icon2.svg' className='h-[20px] w-[20px]' alt="" />
                                        <div className="m-0 font-satoshi font-[400] text-[14px] text-[#19104E]">
                                            {props.accidentData.pickupLocation}
                                        </div>
                                    </div>
                                </div>

                                <div style={{ boxShadow: "0px 2px 4px 0px #00000040" }} className="flex items-center justify-between rounded-[7px] bg-[#FFFFFF] py-[10px] px-[10px]">
                                    <div className="flex gap-[20px] items-center">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/vehicle/icon1.svg' className='h-[20px] w-[20px]' alt="" />
                                        <div className="m-0 font-satoshi font-[400] text-[14px] text-[#19104E]">
                                            {props.accidentData.dropLocation}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="flex items-center col-span-2 gap-[12px]">
                            <p className="m-0 font-[500] text-[#000000] font-satoshi text-[16px]">Estimated Fair is This</p>
                            <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/icon3.svg' className='h-[30px] w-[30px]' alt="" />
                            <p className="m-0 font-[500] text-[#21A6E9] font-satoshi text-[16px]">Mumbai 25 Km </p>
                        </div>
                        <div className="col-span-2 pt-[16px]">
                            <h6 className="m-0 font-satoshi font-[500] text-[32px] text-[#000000] pb-[33px]">Vehicle Type</h6>
                            <div className='bg-[#E6F8FE] border border-[#21A6E9] rounded-[16px] py-[10px] px-[32px] flex items-center gap-[46px]'>
                                <img src={props.accidentData.selectedOptions === 'crane' ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img3.png': props.accidentData.selectedOptions === 'recoveryVan' ? 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img4.png' : 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img5.png'} className='h-[101px] w-[100px]' alt="" />
                                <div>
                                    <h6 className="m-0 font-satoshi font-[500] text-[20px] leading-[28px] text-[#21A6E9]">{props.accidentData.selectedOptions === 'crane' ? 'Hydra Crane' : props.accidentData.selectedOptions === 'recoveryVan' ? 'Mobile Crane' : "Mobile + Hydra Crane"}</h6>
                                    <p className="m-0 font-[400] font-satoshi text-[16px] leading-[30px] text-[#000000]">Get quick service</p>
                                </div>
                            </div>
                            {(props.fromPage === 'quotationUpdate' || props.fromPage === 'AllVehicles') && (
                                <div>
                                    <h3 className="m-0 font-satoshi font-[500] text-[32px] text-[#000000] py-[30px]">Accident Image </h3>
                                    < div className="grid md:grid-cols-3 grid-cols-1 gap-[15px]">
                                        {(isUpdateData || props.accidentData.accidentImage1 !== null) && (
                                            <div className='flex items-center gap-5 p-3 border-b-2 '>
                                                <div>
                                                    <h3 className='text-sm font-base font-semibold font-semibold'>Accident Image 1</h3>
                                                    {!isUpdateData && (<img className='text-sm mt-1 text-gray-600' src={props.accidentData.accidentImage1} alt="PAN Card" style={{ width: '100%', borderRadius: '20px' }} />)}
                                                    {isUpdateData && (
                                                        <input
                                                            type="file"
                                                            name="accidentImage1"
                                                            onChange={handleChange}
                                                            accept="image/*"
                                                            className="form-control font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]"
                                                            required
                                                        />)}
                                                </div>
                                            </div>)}
                                        {(isUpdateData || props.accidentData.accidentImage2 !== null) && (
                                            <div className='flex items-center gap-5 p-3 border-b-2 '>
                                                <div>
                                                    <h3 className='text-sm font-base font-semibold font-semibold'>Accident Image 2</h3>
                                                    {!isUpdateData && (<img className='text-sm mt-1 text-gray-600' src={props.accidentData.accidentImage2} alt="PAN Card" style={{ width: '100%', borderRadius: '20px' }} />)}
                                                    {isUpdateData && (
                                                        <input
                                                            type="file"
                                                            name="accidentImage2"
                                                            onChange={handleChange}
                                                            accept="image/*"
                                                            className="form-control  font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]"
                                                            required
                                                        />)}
                                                </div>
                                            </div>)}
                                        {(isUpdateData || props.accidentData.accidentImage3 !== null) && (
                                            <div className='flex items-center gap-5 p-3 border-b-2 '>
                                                <div>
                                                    <h3 className='text-sm font-base font-semibold font-semibold'>Accident Image 3 </h3>
                                                    {!isUpdateData && (<img className='text-sm mt-1 text-gray-600' src={props.accidentData.accidentImage3} alt="PAN Card" style={{ width: '100%', borderRadius: '20px' }} />)}
                                                    {isUpdateData && (
                                                        <input
                                                            type="file"
                                                            name="accidentImage3"
                                                            onChange={handleChange}
                                                            accept="image/*"
                                                            className="form-control font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]"
                                                            required
                                                        />)}
                                                </div>
                                            </div>)}
                                        {(isUpdateData || props.accidentData.accidentImage4 !== null) && (
                                            <div className='flex items-center gap-5 p-3 border-b-2 '>
                                                <div>
                                                    <h3 className='text-sm font-base font-semibold font-semibold'>Accident Image 4 </h3>
                                                    {!isUpdateData && (<img className='text-sm mt-1 text-gray-600' src={props.accidentData.accidentImage4} alt="PAN Card" style={{ width: '100%', borderRadius: '20px' }} />)}
                                                    {isUpdateData && (
                                                        <input
                                                            type="file"
                                                            name="accidentImage4"
                                                            onChange={handleChange}
                                                            accept="image/*"
                                                            className="form-control font-[500] font-satoshi text-[16px] text-[#000000] pb-[14px]"
                                                            required
                                                        />)}
                                                </div>
                                            </div>)}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='hidden md:block w-full max-w-[555px]'>
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/add/img2.png' className='w-full h-[400px]' alt="" />
                </div>
            </div>
            {isUpdateData && (
            <div className="bg-[#21A6E9] flex items-center max-w-[240px] mx-auto justify-center w-full my-[54px] py-[5px] rounded-full pr-[6px] pl-[26px] cursor-pointer">
                <button onClick={submitUpdatedData} className="font-satoshi font-[400] text-[24px] leading-[33.6px] pr-[8px] text-[#FFFFFF]">Update Details</button>
                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/navbar/right-arrow.svg' className='h-[40px] w-[40px]' alt="" />
            </div>)}
            {/* </div> */}
        </div >
    )
}
export default LookingForAccptance;